module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cna",
    attrs: {
      "id": "f1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/text/9780062948052_Contents#rf1"
    }
  }, [_vm._v("August 2018")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("ER GAZE SLIPS OUT OF FOCUS, TURNING THE VALLEY OF")]), _vm._v(" purple loosestrife into a lavender sea that ebbs and flows in the hot breeze. Smells like cat piss. She continues to push through the scratchy weeds that made their way to North America in the hoof mud of nineteenth-century heifers. Stowaway seeds never meant to cross an ocean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Big-shouldered settlers took up arms against them. Hacking. Burning them alive. One season to the next. One generation to the next. Fathers and sons. Daughters too. Slashing and burning and cursing the flowery invaders. Held them off for decades until an underground river of toxins turned golden cornfields to black muck and sent a town up in a ball of fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With no one left to fight off the loosestrife, it spread. Running rampant across acres of twitch grass and wild rye. Choking every living thing in its path out of existence. Oblivious to the toxic sludge drenching its roots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe thriving because of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Poison doesn’t kill everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young woman is overwhelmed standing in their midst.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A speck. A bug. An orphan child. A lone seed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twenty years old yet feeling eight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shuts her eyes. Grabs hold of that eight-year-old’s hand. Holding tight to the past. Holding on for dear life. She picks up her pace. Knees high. Bare legs etched with tiny cuts from the razor-sharp stems. Should have changed into long pants and sneakers instead of jean shorts and flip-flops. But she didn’t think.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She just bolted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Keys. Ball cap. Car. Gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pit stop at the Quickie to fuel up. Then autopilot kicked in. Like it does when she knows thinking is only going to get in the way. Took the 416 out of the city then Highway 5 along the Rideau River. Knows the highway well now. The fork in the road near the rust red barn. The lopsided flea market billboard that marks the halfway point. And the moss-eaten highway that leads straight into a town that once was but is no more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The town that went up in that fireball. Elgin, Ontario.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A settlement carved from nothing in the 1830s by Mormon missionaries. Made nothing again by greed and spite and toxic wastewater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The late afternoon sun is baking her brain. She lifts her ball cap, pulls sweaty strands of auburn hair from her neck. Twists and tucks her ponytail under the cap. Her dad’s cap. The one from the ’87 Masters when a nobody named Larry Mize beat a couple greats of the game. Her dad loved the underdog. Loved the idea that anybody could do something "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("great. Just once. And that would be enough. That would make his life matter forever. At least that’s how her mother told it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("He wanted to name you after the home of the green jacket.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cap is frayed at the bill. Well worn because a twelve-year-old boy never took it off except when his mother insisted at the dinner table. Frayed because that kid wore it right through high school and beyond. It was part of his off-duty guise. Ball cap, T-shirt and jeans, jean jacket, cowboy boots. Same thing worn by every other country boy from small-town Ontario in the early eighties. Now she wears it. It smells like him. At least she imagines it does. Musty. Like grass from the course where he caddied before becoming a cop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cicadas buzz incessantly. Her tongue sticks to the roof of her mouth. She could die out here and never be found. Collapse in a heap of dehydrated bones and slowly get sucked underground by the loosestrife. Her body liquefied by the wastewater bubbling below. She could die of a thousand cuts. Die of thirst.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But none of these things is going to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not even the mighty loosestrife can mess with her mission. And even though all roads leading to Elgin are permanently barricaded with concrete blockades bearing warning signs that say "), _c('span', {
    staticClass: "make_smallcaps"
  }, [_vm._v("ROAD CLOSED. DO NOT ENTER. HAZARDOUS TOXIC WASTE. UNAUTHORIZED ENTRY BANNED")]), _vm._v(". Even though the fields around the town look more like a demilitarized no-go zone than a once-thriving farming community. Nothing is going to stop her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She drops into the past. Sinking into the cave of her memories. A habit she mastered as a kid in boarding school. It "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("comforts her. And if she tries hard enough, conjures the tiniest scrap of memory—a color, a smell, a sensation on her skin, a word spoken by someone she loved—she can see the past projected onto the walls of her imagination. Once there, she can alter those flickerings to her liking. Reshape the past. Bring people back. Undo the horrible things that happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If only for a sweet second.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s a hard habit to break.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twenty-five minutes. That’s far enough to get her head straight and her feet moving. Twenty-five minutes and a mile back she goes. When she parked in the dirt lane off Highway 15 just east of Upper Rideau Lake. Same shady spot under the weeping willow. Locked the Buick, pocketed the keys, headed out on foot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Destination: Halladay House.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two clicks inside the no-go zone, up the rolling hill, over the cedar rail fence. Then along the eastern boundary of the Halladay acreage. Steering clear of the chemical ponds that dot the west side of the property. She knows the lay of the land. Knows the stench of diesel and naphthalene that hangs in the air. Knows the slippery footing along the soggy banks of the creek of wastewater runoff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just like the loosestrife, she’s a stranger. A trespasser who’s made herself at home. She’s scaled the barbed-wire fence around the defunct compressor station and yanked ivy from the headstones of graves. She’s pried plywood from windows. Walked down the main street, past a grocery store where people once stopped to gossip and buy their milk and eggs. She’s even sat on the wooden pews where they prayed every Sunday seeking salvation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("Seems their God wasn’t listening.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now she’s back. A can of gasoline in tow. Hiking toward that big old house that sits outside town. A nineteenth-century Gothic farmhouse perched on the brow of a purple knoll. Majestic veranda limping sideways from rot. Moss dripping from its shingles. A widow’s walk clings to the rooftop like a spider hovering over its prey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has only seen the house once before by moonlight. It’s the mansion where Kep Halladay lived. Where he lorded over the county. Stole from the work-worn pockets of his neighbors. Sucked the lifeblood from the very land surrounding his own home. Until he destroyed everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s come to finish what her mother started.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Come to set her eyes upon Halladay House in the light of day, one last time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before she burns it to the ground."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe1d85b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062948052_AUGUST_2018.vue
// module id = 69
// module chunks = 0